//TODO adapt
export const ENVIRONMENT_GLOBAL = {
  envName: 'global',
  loggingEnabled: true,
  production: true,
  pageSize: 25,
  unlimitedPageSize: 1000,
  searchSelectPageSize: 10,
  debounceTime: 750,
  debounceTimeSearchSelect: 200,
  inputErrorSnackbarDuration: 3000,
  dialogs: {
    xlarge: {
      width: '90vw',
      maxWidth: '1200px',
      minWidth: '350px'
    },
    large: {
      width: '80vw',
      maxWidth: '775px',
      minWidth: '350px'
    },
    small: {
      width: '600px',
    },
    xsmall: {
      width: '400px',
    }
  },
  appVersion: require('../../package.json').version,
  redirect: {
    route: '/oauth'
  },
  auth_L1: {
    endpoint: {
      paths: {
        account: '/account',
        login: '/protocol/openid-connect/auth',
        token: '/protocol/openid-connect/token',
        certs: '/protocol/openid-connect/certs',
        logout: '/protocol/openid-connect/logout',
        register: '/protocol/openid-connect/registrations'
      }
    }
  },
  backend: {
    endpoint: {
      paths: {
        prefix: '/api/spm',
        token: '/auth/token',
        logout: '/auth/logout'
      },
      host: ''
    }
  },
  customers: {
    endpoint: {
      paths: {
        prefix: '/customers',

      }
    }
  },
  customerSystems: {
    endpoint: {
      paths: {
        prefix: '/customers/',
        postfix: '/systems'

      }
    }
  },
  Products: {
    endpoint: {
      paths: {
        prefix: '/producttypes'
      }
    }
  },
  systemProducts: {
    endpoint: {
      paths: {
        prefix: '/customers/',
        postfix: '/systems/'

      }
    }
  },
   productSystems: {
    endpoint: {
      paths: {
        prefix: '/products/',
        postfix: '/systems'
      }
    }
  },
  tasks: {
    endpoint: {
      paths: {
        prefix: '/tasks',
        open: '/open',
        complete: '/complete',
        sync: '/sync',
        state: '/state'
      }
    }
  },
  versionFinder: {
     endpoint: {
      paths: {
         prefix: '/versionfinder',

      }
    }

  }
};
